import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

export default function ContractSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [lastName, setLastName] = useState(props.lastName || "");
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");
  const [odometer, setOdometer] = useState(props.odometer || "");
  const [moreThanEightVin, setMoreThanEightVin] = useState(false);
  const [moreThanSixOdometer, setMoreThanSixOdometer] = useState(false);

  useEffect(() => {
    if (typeof props.onFormUpdate === "function") {
      props.onFormUpdate({
        lastName: lastName,
        last8Vin: last8Vin,
        odometer: odometer,
      });
    }
  }, [lastName, last8Vin, odometer]);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onSubmit === "function") {
      props.onSubmit({
        lastName: lastName,
        last8Vin: last8Vin,
        odometer: odometer,
      });
    }
    return false;
  };

  // useEffect( () => {
  //   if(typeof formRef.current === 'undefined'){ return; }

  //   if(typeof props.onFormLoad === 'function'){
  //     props.onFormLoad(formRef.current);
  //   }
  // }, [formRef.current]);

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  const odometerLen = (e) => {
    if (e.target.value.length > 6) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanSixOdometer(true);
      devLog("Odometer Length error");
    } else if (e.target.value <= 0) {
      e.target.value = "";
      setMoreThanSixOdometer(false);
      setOdometer("");
      devLog("Odometer cannot be zero or less");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <div className="group-1">
            <div className="label">{t("description.ConfirmCustomerLastName")}:</div>
            <input
              type="text"
              placeholder={t("description.ConfirmCustomerLastName")}
              name="lname"
              className="input form-control required"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value || "");
              }}
              required
            />
          </div>

          <div className="group-1">
            <div className="label">{t("description.ConfirmCustomerLast8VIN1")}:</div>
            <input
              type="text"
              placeholder={t("description.ConfirmCustomerLast8VIN2")}
              name="l8vin"
              className="input form-control required"
              value={last8Vin}
              onChange={(e) => {
                setMoreThanEightVin(false);
                vinInputLength(e);
                setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
              }}
              required
            />
          </div>
          {moreThanEightVin && <Alert severity="error">{t("description.VinInputErrorMsg")}</Alert>}

          <div className="group-1">
            <div className="label">{t("LDS.ContractSearch.Odometer1")}:</div>
            <input
              type="number"
              placeholder="123456"
              name="odometer"
              className="input form-control required"
              value={odometer}
              onChange={(e) => {
                setMoreThanSixOdometer(false);
                odometerLen(e);
                setOdometer(e.target.value?.replace(/\D/g, "")?.trim() || "");
              }}
              required
            />
          </div>
          {moreThanSixOdometer && <Alert severity="error">{t("description.OdometerInputErrorMsg")}</Alert>}
          <div className="footerContainer" style={{ display: "flex" }}>
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={() => {
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
